module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<label class="b-input b-booking-form-contacts-autocomplete ' +
((__t = ( classes )) == null ? '' : __t) +
'">\n	<span class="b-input__label b-booking-form-contacts-autocomplete__label">' +
((__t = ( label )) == null ? '' : __t) +
'</span>\n	<input class="b-input__value b-booking-form-contacts-autocomplete__value" type="text" placeholder="' +
((__t = ( placeholder )) == null ? '' : __t) +
'">\n</label>\n';

}
return __p
}